export default __webpack_public_path__ + "static/vtu_poster-6261e2d5643680f188e676b39fbf5685.jpg";